// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@font-face{font-family:Source Han Sans CN;src:url(https://bh-softwareshop.shoss.xstore.ctyun.cn/ztb/SourceHanSansCN-Medium.otf);font-weight:400;font-style:normal}@font-face{font-family:PingFang SC;src:url(https://bh-softwareshop.shoss.xstore.ctyun.cn/ztb/PingFang%20Bold.ttf);font-weight:400;font-style:normal}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
